import Cookie from 'js-cookie';

export default class Cart {

  constructor() {
    this.setupProductLinks();
    this.submitNotifyListener();

    this.cache_timeout = 10 * 60 * 500; // 5 mins
  }

  getShopDomain() {
    //get domain, remove subdomain
    var separate = window.location.hostname.split('.');
    separate.shift();
    var domain = separate.join('.');
    if (domain.indexOf('.com') !== -1) {
      domain = 'https://www.' + domain;
    } else {
      domain = 'http://www.' + domain;
    }

    return domain;
  }

  setupProductLinks() {
    var self = this;
    //setup all the products for the add to cart button.
    var $addAllLink = $('.add-all-to-cart');
    var pids = {}, notifyPids = [];
    $('.product-buy').not('.notify').each(function() {
      var $link = $(this);
      var pid = $link.data('pid');
      var price = $link.data('price');
      var add = {};
      var quantity = $(this).data('qty') || 1;
      add[pid] = { "quantity": quantity, "price": price };
      $.extend(pids, add);
    });

    $('.notify.product-buy').each(function() {
      var pid = $(this).data('pid');
      notifyPids.push(pid);
    });

    $addAllLink.attr('data-multi-add', JSON.stringify(pids));

    $addAllLink.addToCart({
      onAdded : function(cartData) {
        this.html('Added!');
        $('.product-buy').not('.notify').html("Added!");

        if (notifyPids.length > 0) {
          self.handleNotifyAction(notifyPids);
        }
      }
    });

    //setup single link add to cart clicks
    $('.product-buy').not('.notify, .subscription').addToCart({
      onAdded: function(cartData) {
        this.html('Added!');
      }
    });

    if (Cookie.get('cart_count')) {
      self.updateCartCount();

      var token = $( 'meta[name="csrf-token"]' ).attr( 'content' );

      var cached;
      if(localStorage && (cached = localStorage.getItem('cache-learn-cart'))) {
        try {
          cached = JSON.parse(cached);

          if(cached.timestamp && (Date.now() < cached.timestamp)) {
            self.updateProductButtonStatus(cached.data);
            self.updateCartCount();

            return;
          }
        } catch(e) {}
      }

      $.ajax({
          url: $.wildCart.wildCartGetCart,
          accept: 'application/json',
          crossDomain: true,
          cache: false,
          xhrFields: {
             withCredentials: true
          },
          type: 'POST',
          beforeSend: function (xhr) {
            xhr.setRequestHeader( 'X-CSRF-Token', token );
          },
          error: function(jqXHR, textStatus, errorThrown) {
              console.log(' :( ' +  textStatus.toUpperCase()  + ' -- for ajaxAdd() : jqXHR.statusText = ' + jqXHR.statusText + ', textStatus = ' + textStatus);
          },
          success: function(data, textStatus, jqXHR) {
            if(localStorage) {
              localStorage.setItem('cache-learn-cart', JSON.stringify({
                timestamp: Date.now() + self.cache_timeout,
                data: data
              }));
            }

            self.updateProductButtonStatus(data);
            self.updateCartCount();
          }
      });
    }
  }

  updateProductButtonStatus(data) {
    if (data && data["cart"]) {
      $.each( data["cart"], function(key, value){
        $('#' + key + '-product').html("Added!");
      });
    }
  };

  updateCartCount() {
    var text = "", cartCount = Cookie.get('cart_count');

    text = "<i class='fa fa-shopping-cart'></i> " + cartCount;

    $('.cart a').html(text);
  };

  handleNotifyAction(productIds) {
    if (!productIds.length) {
      return;
    } else if (productIds.length === 1) {
      $('.notify-modal-form-header').text('Oh No! The following item is not currently in stock:');
      $('.notify-modal-form-notice').text('Please enter your details below and we will send you an e-mail when this item is back in stock! You will only be e-mailed about this product!');
    } else {
      $('.notify-modal-form-header').text('Oh No! You tried to add the following items to your cart, but they are not in stock right now:');
      $('.notify-modal-form-notice').text('Please enter your details below and we will send you an e-mail when these items are back in stock! You will only be e-mailed about these products!');
    }

    $('#notify-modal-form, #notify-modal .modal-body .product, .notify-modal-form-header').show();
    $('#notify-modal-success').hide();
    $('#close-notify').hide();
    $('#submit-notify').show();
    $('#notify-modal .product').remove();

    $.each(productIds, function(index, value) {
      var $productLink = $('#' + value + '-product');

      var $product = $productLink.closest('.product-wrapper');

      var $productTitle = $('.product-title', $product).first().clone();
      var product = $('<p />', { 'class': 'product'})
        .append($productTitle.text().toUpperCase());
      product.data('id', value);

      $('#notify-modal .notify-modal-products').append(product);
    });

    $('#notify-modal').modal('show');
  }

 submitNotifyListener() {
   var self = this;
    $('.notify.product-buy').on('click', function(event) {
      // TODO: Temporarily remove the modal handling in learn of the
      // out of stock notifications. We need to re-build the server to server
      // api from learn to shop for out of stock notifications similar to cart.
      return;
      event.preventDefault();
      var product_id = parseInt($(this).attr('id'), 10);
      self.handleNotifyAction([product_id]);
    });

    $('#submit-notify').on('click', function(event) {
      event.preventDefault();

      var emailPattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);

      if ($('input[name="name"]').val().length < 2) {
        $('.notify-modal-form-notice').html("Please enter your name before submitting.");
        $('.notify-modal-form-notice').css('font-weight', 'bold');
        return;
      } else if (!emailPattern.test($('input[name="email"]').val())) {
        $('.notify-modal-form-notice').html("Please enter a valid email before submitting.");
        $('.notify-modal-form-notice').css('font-weight', 'bold');
        return;
      }

      var productIds = [];
      $('#notify-modal .product').each(function() {
        productIds.push($(this).data('id'));
      });


      if (productIds.length) {
        self.submitNotify(productIds[0], self.submitNotifyResponse);
      }
    });
  }

  submitNotify(id, cb) {
    $.ajax({
      //url: "https://www.adafruit.com/index.php?main_page=back_in_stock_notification_subscribe&hidden=yes&part_id=" + id,
      url: this.getShopDomain() + "/index.php?main_page=back_in_stock_notification_subscribe&hidden=yes&part_id=" + id,
      type: "POST",
      data: $('#notify-modal-form').serialize(),
      crossdomain: true,
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
      xhrFields: { withCredentials: true },
      beforeSend: function ( xhr ) {
          $('#submit-notify').text('Working...').addClass("disabled");
      },
      error: function (data) {
        //console.log(data);
      },
      success: function (data) {
        cb(id, data);
        //console.log(data);
      }
    });
  }

  submitNotifyResponse(id, data) {
    var nextIndex = productIds.indexOf(id) + 1;
    if (nextIndex < productIds.length) {
      this.submitNotify(productIds[nextIndex], this.submitNotifyResponse);
    } else {
      //show modal body submission success.  Close Submit..just like feedback form.
      $('#submit-notify').remove();
      var response = "<div class='feedback-response'>" + data + "</div>";
      $('#notify-modal-form, #notify-modal .modal-body .product, .notify-modal-form-header').hide();
      $('#notify-modal h3').text("Subscription Successful!");
      $('#notify-modal-success').show();
      $('#submit-notify').hide();
      $('#close-notify').show();
    }
  }
}
